// Global state to track refresh attempts
export const MAX_REFRESH_ATTEMPTS = 3;

// Show login dialog by dispatching a custom event
export const showLoginDialog = () => {
  window.dispatchEvent(new CustomEvent('show-login-dialog'));
};
